export default (state = {}, action) => {
  let { type, payload } = action
  switch (type) {
    case 'FETCH_USER_DATA_SOURCE':
      return payload
    case 'LOGOUT':
      return null
    default:
      return state
  }
}
